import { render, staticRenderFns } from "./CampaignCustomers.vue?vue&type=template&id=49151982&scoped=true&"
import script from "./CampaignCustomers.vue?vue&type=script&lang=ts&"
export * from "./CampaignCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignCustomers.vue?vue&type=style&index=0&id=49151982&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49151982",
  null
  
)

export default component.exports